import { render, staticRenderFns } from "./AtaDashboard.vue?vue&type=template&id=8b6cdca2&scoped=true"
import script from "./AtaDashboard.vue?vue&type=script&lang=js"
export * from "./AtaDashboard.vue?vue&type=script&lang=js"
import style0 from "./AtaDashboard.vue?vue&type=style&index=0&id=8b6cdca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6cdca2",
  null
  
)

export default component.exports